export interface Shortcut {
  id: string;
  action: string;
  description?: string;
  keys: string[];
  group: 'Navigation' | 'Workflows' | 'Allgemein' | 'Tabellen' | 'Dialoge';
}

export type ShortcutGroup = Shortcut['group'];

export const SHORTCUTS = [
  { id: 'cmd-k', action: 'Befehlspalette öffnen', description: 'Schnellzugriff auf Seiten, Aktionen, Workflows', keys: ['Cmd', 'K'], group: 'Navigation' },
  { id: 'shortcuts', action: 'Tastatur-Übersicht anzeigen', keys: ['?'], group: 'Navigation' },
  { id: 'go-dashboard', action: 'Zum Dashboard', keys: ['G', 'D'], group: 'Navigation' },
  { id: 'go-accounting', action: 'Zur Buchhaltung', keys: ['G', 'B'], group: 'Navigation' },
  { id: 'go-operations', action: 'Zur Operativ-Ansicht', keys: ['G', 'O'], group: 'Navigation' },

  { id: 'theme-toggle', action: 'Theme wechseln', description: 'Hell / System / Dunkel', keys: ['Shift', 'T'], group: 'Allgemein' },
  { id: 'locale-switch', action: 'Sprache wechseln', description: 'DE / EN', keys: ['Shift', 'L'], group: 'Allgemein' },

  { id: 'wf-first-invoice', action: 'Workflow: Erste Rechnung', keys: ['W', 'R'], group: 'Workflows' },
  { id: 'wf-bank-import', action: 'Workflow: Bankimport', keys: ['W', 'B'], group: 'Workflows' },
  { id: 'wf-monthly-close', action: 'Workflow: Monatsabschluss', keys: ['W', 'M'], group: 'Workflows' },

  { id: 'select-all', action: 'Alle Zeilen auswählen', keys: ['Cmd', 'A'], group: 'Tabellen' },
  { id: 'search', action: 'Tabelle durchsuchen', keys: ['/'], group: 'Tabellen' },

  { id: 'esc-close', action: 'Dialog schließen', keys: ['Esc'], group: 'Dialoge' },
  { id: 'enter-confirm', action: 'Aktion bestätigen', keys: ['Enter'], group: 'Dialoge' },
] as const satisfies readonly Shortcut[];

export function detectPlatform(): 'mac' | 'win' {
  if (typeof navigator === 'undefined') return 'win';
  return /Mac|iPhone|iPad/i.test(navigator.platform) ? 'mac' : 'win';
}

export function formatShortcut(keys: string[], platform: 'mac' | 'win'): string {
  return keys
    .map((key) => {
      if (key === 'Cmd') return platform === 'mac' ? '\u2318' : 'Strg';
      if (key === 'Alt') return platform === 'mac' ? '\u2325' : 'Alt';
      if (key === 'Shift') return platform === 'mac' ? '\u21E7' : 'Umschalt';
      return key;
    })
    .join(platform === 'mac' ? '' : '+');
}
